module.exports = __webpack_public_path__ + "media/images/upload-example-5-74174ed83bfe2ac464356053015c4ed0.png";